/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import api from '@api';
import { Button, LoadingOverlay, toast } from '@components';
import { usePrintAccountStatement, useRequest, useRequestStatus } from '@hooks';

import './style.scss';

const AccountStatementReport = () => {
  const { year, month } = useParams();

  const [reportContent, setReportContent] = useState('');
  const [reportContentStatus, setReportContentStatus] = useRequestStatus();
  const [openBrowserWindowToPrint] = usePrintAccountStatement();

  const [accountStatement, , accountStatementError, fetchAccountStatement] = useRequest(
    payload => api.get('traders/me/accountStatement', payload)
  );

  const handlePrintAccountStatement = () => {
    openBrowserWindowToPrint(
      `/movements/account-statement/${month}/${year}`,
      reportContent
    );
  };

  useEffect(() => {
    const getReportContent = () => {
      setReportContentStatus('pending');

      const payload = { year, month };

      fetchAccountStatement(payload);
    };

    if (!reportContent) {
      getReportContent();
    }
  }, [
    month,
    reportContent,
    setReportContent,
    setReportContentStatus,
    year
  ]);

  useEffect(() => {
    if (accountStatement) {
      setReportContent(accountStatement?.data);

      setReportContentStatus('resolved');
    }
  }, [accountStatement]);

  useEffect(() => {
    if (accountStatementError) {
      toast.danger(
        'Algo salió mal al obtener tu estado de cuenta, inténtalo de nuevo'
      );

      setReportContentStatus('rejected');
    }
  }, [accountStatementError]);

  return (
    <div styleName="account-statement-overflow">
      <div styleName="account-statement">
        {reportContentStatus.isPending && (
          <LoadingOverlay tid="loading-overlay" />
        )}

        {reportContentStatus.isResolved && (
          <div styleName="account-statement-actions">
            <Button
              id="print-button"
              tid="print-button"
              type="button"
              onClick={handlePrintAccountStatement}
            >
              Descargar
            </Button>
          </div>
        )}
        <div styleName="account-statement-content">
          <div
            id="report-content"
            tid="report-content"
            dangerouslySetInnerHTML={{ __html: reportContent }}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountStatementReport;
